import { render, staticRenderFns } from "./MyArticle.vue?vue&type=template&id=7a641e8c&scoped=true"
import script from "./MyArticle.vue?vue&type=script&lang=js"
export * from "./MyArticle.vue?vue&type=script&lang=js"
import style0 from "./MyArticle.vue?vue&type=style&index=0&id=7a641e8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a641e8c",
  null
  
)

export default component.exports